import React, { useContext, useEffect, useState } from "react";
import deleteButton from "../../assets/images/marketplace/Delete.png";
import dummyimage from "../../assets/images/marketplace/dummyImage.png";
import minus from "../../assets/images/marketplace/minus.png";
import plus from "../../assets/images/marketplace/plus.png";
import bag from "../../assets/images/marketplace/Union.png";
import verified from "../../assets/images/marketplace/verified.png";
import { Button } from "@material-ui/core";
import moment from "moment/moment";
import { CartContext } from "../../context/CartContext";
import { useNavigate } from "react-router-dom";
import OrderStatus from "./../orderStatus/index";

export default function CartItem(props) {
  const { isCart, product } = props;
  const [cart, setCart] = useContext(CartContext);
  const [productValue, setPrdoductValue] = useState(0);
  const navigate = useNavigate();
  useEffect(() => {
    setPrdoductValue(product?.productInfo?.quantity);
  }, [productValue, product?.productInfo?.quantity]);
  const handleDeleteProduct = (product) => {
    const productIndex = cart.findIndex(
      (cartProduct) =>
        cartProduct?.productInfo?._id === product?.productInfo?._id
    );
    if (productIndex !== -1) {
      if (product[productIndex]?.productInfo?.quantity > 1) {
        // Create a new array without the product to delete
        const updatedCart = [
          ...cart.slice(0, productIndex),
          ...cart.slice(productIndex + 1),
        ];

        // Update the cart state with the updated array
        setCart(updatedCart);
        localStorage.setItem("cart", JSON.stringify(updatedCart));
      } else {
        const updatedCart = cart.filter((delProduct) => {
          return delProduct?.productInfo?._id !== product?.productInfo?._id;
        });
        setCart(updatedCart);
        localStorage.setItem("cart", JSON.stringify(updatedCart));
      }
    }
  };
  const handleProductValue = (operation, product) => {
    const updatedCart = [...cart]; // Create a copy of the cart array

    const productIndex = updatedCart.findIndex((cartProduct) => {
      return cartProduct?.productInfo?._id === product?.productInfo?._id;
    });

    if (productIndex !== -1) {
      if (operation === "add") {
        updatedCart[productIndex].productInfo.quantity += 1;
      } else if (operation === "remove") {
        if (updatedCart[productIndex]?.productInfo?.quantity === 1) {
          handleDeleteProduct(product);
        } else {
          updatedCart[productIndex].productInfo.quantity -= 1;
        }
      }
      setCart(updatedCart); // Update the cart state with the updated array
      localStorage.setItem("cart", JSON.stringify(updatedCart));
    }
  };

  return (
    <div className="CartItemMainContainer">
      {/* left  */}
      <div className="leftCartContainer">
        <div className="leftImageContainer">
          <img
            src={product?.productInfo?.images[0]}
            className="product-image__cart"
            alt="product"
            onClick={() => {
              if (isCart) {
                navigate(`/marketplace/single/${product?.productInfo?._id}`);
              } else {
                navigate(
                  `/marketplace/order_received/${product?.orderInfo?._id}`
                );
              }
            }}
          />
        </div>
        <div className="leftImageBag">
          {product?.productInfo?.discount > 0 && (
            <p className="font10blue">
              -
              {Math.round(
                (product?.productInfo?.discount / product?.productInfo?.price) *
                  100
              )}
              %
            </p>
          )}
          <img src={bag} alt="bag" />
        </div>
      </div>
      {/* right  */}
      <div className="rightCartContainer font10">
        <p className="firstpara">{product?.productInfo?.title}</p>
        <div className="secoundpara">
          <div>
            <p>Original price</p>
            <p>
              ₹ {product?.productInfo?.price - product?.productInfo?.discount}
            </p>
            {isCart && (
              <p className="lineOverthetext">₹ {product?.productInfo?.price}</p>
            )}
          </div>
          <div className="font10blue">
            <p>Runs</p>
            <p>{product?.productInfo?.runs}</p>
            {/* {isCart &&  <p className='lineOverthetext'>12000</p>} */}
          </div>
        </div>
        <div className="thirdpara">
          {/* iscart is true means its use in cart page otherwise its use in order Page */}

          {isCart ? (
            <>
              <div>
                <img
                  src={product?.sellerInfo?.sellerProfile || dummyimage}
                  className="seller-image--cart"
                />
              </div>
              <div style={{ paddingLeft: "8px" }}>
                <div style={{ display: "flex" }}>
                  <p style={{ paddingRight: "15px" }}>
                    {product?.sellerInfo?.sellerName}
                  </p>
                  {product?.sellerInfo?.isSellerVerified && (
                    <img src={verified} />
                  )}
                </div>
                <p className="cart__product-creation-date">
                  Created on{" "}
                  {moment(product?.productInfo?.createdDate)?.format("L")}
                </p>
              </div>
            </>
          ) : (
            <div className="font10">
              Ordered on{" "}
              {moment(product?.orderInfo?.createdDate)?.format("MM/DD/YYYY") ||
                "05-10-2023"}
            </div>
          )}
        </div>
        <div
          className="fourthpara"
          style={{ paddingTop: !isCart ? "10px" : "3px" }}
        >
          {isCart ? (
            <>
              <div className="buttonContainer">
                <div className="buttonchildContainer">
                  <img
                    src={minus}
                    className="cart-change__cursors"
                    onClick={() => handleProductValue("remove", product)}
                  />
                </div>
                <div className="buttonchildContainer numercountsize">
                  {productValue}
                </div>
                <div className="buttonchildContainer">
                  <img
                    src={plus}
                    className="cart-change__cursors"
                    onClick={() => handleProductValue("add", product)}
                  />
                </div>
              </div>
              <div className="deleteButtoncontainer">
                <img
                  src={deleteButton}
                  className="cart-change__cursors"
                  onClick={() => handleDeleteProduct(product)}
                />
              </div>
            </>
          ) : (
            <div className="orderContaier1">
              <p>Status</p>
              <Button className="orderButton">
                {product?.orderInfo?.currentState || "Order Placed"}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
